module.exports = __webpack_public_path__ + "6297d70825443ad57ea3ef13324a2b3c.png";